module.exports = __webpack_public_path__ + "static/media/ic-alert.655fe0e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-alert.svg
// module id = 587
// module chunks = 14